import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Tiny build-info badge that lives in the sidebar footer.
 * Lets you confirm at a glance which commit production is actually serving —
 * critical to detect "deploy didn't update" situations.
 */
export default function VersionBadge() {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/version").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return null;

  const commit = info.commit || "unknown";
  const dateStr = info.commit_date
    ? new Date(info.commit_date).toLocaleDateString("pt-BR", {
        day: "2-digit", month: "2-digit", year: "2-digit",
      })
    : "—";
  const envColor =
    info.env === "production" ? "text-emerald-400" : "text-amber-400";

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="version-badge"
        className="w-full text-left text-[10px] text-muted-foreground/70 hover:text-muted-foreground px-2 py-1 mt-1 font-mono tracking-tight transition-colors"
        title="Ver detalhes da build"
      >
        <span className={`${envColor} font-semibold`}>●</span>{" "}
        build <span className="text-foreground/70">{commit}</span> · {dateStr}
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
          onClick={() => setOpen(false)}
          data-testid="version-modal"
        >
          <div
            className="bg-[#0A1424] border border-border rounded-xl p-6 max-w-sm w-full font-mono text-xs"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-sm font-display font-bold mb-4">Build info</div>
            <Row label="commit" value={info.commit} />
            <Row label="data do commit" value={info.commit_date || "—"} />
            <Row label="branch" value={info.branch || "—"} />
            <Row label="boot (servidor)" value={info.boot_time} />
            <Row label="ambiente" value={info.env || "—"} />
            <button
              onClick={() => setOpen(false)}
              data-testid="version-modal-close"
              className="mt-4 w-full text-xs py-2 rounded border border-border hover:bg-accent/50 transition-colors"
            >
              fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}

const Row = ({ label, value }) => (
  <div className="flex justify-between gap-3 py-1 border-b border-border/40">
    <span className="text-muted-foreground">{label}</span>
    <span className="text-foreground truncate text-right">{value}</span>
  </div>
);
